import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeadChevronRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M25.2 7.2q1 0 1.5 1l4.1 7q.5.7 0 1.5l-4 7.2q-.6.8-1.7.9H2.2q-.8-.4-.5-1l3.8-7.6v-.4L1.7 8.3V8q.1-.8.8-.8h22.6M7.8 14.6a3 3 0 0 1 0 2.8l-2.4 4.8h19.3l3.5-6.2-3.5-6.2H5.4z" })
});
export default SvgLeadChevronRegularIcon;
